module.exports = __webpack_public_path__ + "static/img/9.9ec7107.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/9.png
// module id = cKzm
// module chunks = 0